module.exports = __webpack_public_path__ + "static/garnishings03-9e6a3718dd3bb45c5d967e4f223bcf59.jpg";